var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHockey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "80.68 0.2 25.97 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "so-hockey",
    clipPath: "url(#clip0_695_2020)",
    filter: "url(#filter0_dddddd_695_2020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M96.2623 19.3984H91.0692C90.3805 19.3984 89.7201 19.6682 89.2332 20.1482C88.7462 20.6283 88.4727 21.2795 88.4727 21.9584C88.4727 22.6374 88.7462 23.2885 89.2332 23.7686C89.7201 24.2487 90.3805 24.5184 91.0692 24.5184H96.2623C96.9509 24.5184 97.6113 24.2487 98.0983 23.7686C98.5852 23.2885 98.8588 22.6374 98.8588 21.9584C98.8588 21.2795 98.5852 20.6283 98.0983 20.1482C97.6113 19.6682 96.9509 19.3984 96.2623 19.3984Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.7975 2.75944C85.4045 2.16786 84.8002 1.74371 84.1046 1.5713C83.4089 1.3989 82.673 1.49084 82.043 1.82888C81.7147 2.01088 81.4294 2.25935 81.2056 2.55794C80.9818 2.85652 80.8247 3.19845 80.7446 3.56121C80.6645 3.92398 80.6633 4.29935 80.7409 4.66263C80.8186 5.0259 80.9734 5.36884 81.1952 5.66888L83.6281 8.96104L88.2578 6.32552L85.7975 2.75944Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M102.523 14.6367L94.5856 15.4892L89.7236 8.44922L85.168 11.0412L88.511 15.5596L89.7041 17.0419C90.148 16.9139 90.6075 16.8459 91.0699 16.8396H96.263C97.6402 16.8396 98.9611 17.379 99.935 18.3392C100.909 19.2994 101.456 20.6017 101.456 21.9596H102.926C103.432 21.9599 103.933 21.8585 104.398 21.6615C104.863 21.4644 105.283 21.1759 105.631 20.8137C105.98 20.4514 106.249 20.0229 106.424 19.5543C106.599 19.0858 106.675 18.5871 106.647 18.0886C106.62 17.5901 106.49 17.1024 106.265 16.6552C106.04 16.2081 105.725 15.8108 105.339 15.4877C104.953 15.1647 104.504 14.9226 104.02 14.7763C103.536 14.63 103.027 14.5825 102.523 14.6367Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_695_2020",
    x: 0.683594,
    y: 0.199219,
    width: 185.965,
    height: 205.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.143771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_695_2020",
    result: "effect2_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.119221 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_695_2020",
    result: "effect3_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_695_2020",
    result: "effect4_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0807786 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_695_2020",
    result: "effect5_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0562291 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_695_2020",
    result: "effect6_dropShadow_695_2020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_695_2020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_2020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9653,
    height: 25.6,
    fill: "white",
    transform: "translate(80.6836 0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/hockey.86952418567717a6d366ca82d3330660.svg";
export { ForwardRef as ReactComponent };